import { FC, useCallback } from 'react'

import {
  ApproversField,
  ConfigFormTemplate,
  InputSelectControlField,
  useApprovers
} from 'Automations/nodeDefinitions/components'
import { ConfigFormProps } from 'Automations/nodeDefinitions/types'
import { useNode } from 'Automations/nodeDefinitions/hooks'
import { reviewTypeLabel, reviewTypeTargetDefinition } from '..'
import { Config } from '.'
import {
  ROLES_WITH_FULL_PRODUCT_ACCESS,
  SystemRoles
} from 'lib/rbac/systemRoles'

export const ReviewContractConfigForm: FC<ConfigFormProps> = ({ nodeId }) => {
  const {
    nodeData,
    setNodeData,
    updateNodeType,
    definition,
    validationErrors
  } = useNode<Config>({ nodeId })

  const filterUserByFullProductAccess = useCallback(
    (user: { roles: string[] }) =>
      user.roles.some(role =>
        ROLES_WITH_FULL_PRODUCT_ACCESS.includes(role as SystemRoles)
      ),
    []
  )

  const {
    userOptions,
    approvers,
    isPending: isUsersPending,
    multiSelectKey,
    removeApprover
  } = useApprovers({
    approverUserIds: nodeData?.approverUserIds ?? [],
    onChange: ids => setNodeData('approverUserIds', ids),
    filterUser: filterUserByFullProductAccess
  })

  if (!nodeData || !definition) return null

  return (
    <ConfigFormTemplate>
      <ConfigFormTemplate.Header nodeId={nodeId} />

      <ConfigFormTemplate.Row label="Review">
        <InputSelectControlField
          data-testid="automations.editor.configForm.review.reviewType"
          value={nodeData.reviewType}
          placeholder="Select type..."
          options={Object.entries(reviewTypeLabel).map(([value, label]) => ({
            value,
            label
          }))}
          onChange={reviewType => {
            updateNodeType(
              reviewTypeTargetDefinition[reviewType as Config['reviewType']],
              { approverUserIds: nodeData?.approverUserIds ?? [] }
            )
          }}
          validationErrors={validationErrors.reviewType}
        />
      </ConfigFormTemplate.Row>

      <ApproversField
        testIdPrefix="automations.editor.configForm.review"
        approvers={approvers}
        onRemoveApprover={removeApprover}
        userOptions={userOptions}
        approverUserIds={nodeData.approverUserIds}
        isUsersPending={isUsersPending}
        multiSelectKey={multiSelectKey}
        onApproversChange={userIds => setNodeData('approverUserIds', userIds)}
        validationErrors={validationErrors.approverUserIds}
      />
    </ConfigFormTemplate>
  )
}
